// extracted by mini-css-extract-plugin
export var searchExpand = "subscribe-module--search-expand--fxS5h";
export var expand = "subscribe-module--expand--jgTN6";
export var searchCollapse = "subscribe-module--search-collapse--12CX5";
export var popover = "subscribe-module--popover--LAyih";
export var popoverInner = "subscribe-module--popoverInner--zg841";